import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class UtilityService extends Service {
  async getMeasurement() {
    const httpResponse = await this.httpClient.get('/unidademedida')
    return httpResponse
  }

  async getBrand(params?: any) {
    const httpResponse = await this.httpClient.get('/marca', { params })
    return httpResponse
  }

  async getCarmaker() {
    const httpResponse = await this.httpClient.get('/montadora')
    return httpResponse
  }

  async getModel(params?: any) {
    const httpResponse = await this.httpClient.get('/modelo', { params })
    return httpResponse
  }

  async getModelFamilies(params?: any) {
    const httpResponse = await this.httpClient.get('/modelo/familias', {
      params
    })
    return httpResponse
  }

  async getModelCategory() {
    const httpResponse = await this.httpClient.get('/modelo/categorias')
    return httpResponse
  }

  async getCR(params?: any) {
    const httpResponse = await this.httpClient.get('/centroresultado', {
      params
    })
    return httpResponse
  }

  async getDirectorship(params?: any) {
    const httpResponse = await this.httpClient.get('/diretoria', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getColors() {
    const httpResponse = await this.httpClient.get('/cor')
    return httpResponse
  }

  async getCategoryGroup(params?: any) {
    const httpResponse = await this.httpClient.get('/grupocategoria', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }
}

export const utilityService = new UtilityService()
